import { motion } from "framer-motion";
import { MessageCircle } from "lucide-react";
import { waLink, WA_MESSAGES } from "./data";

export default function WhatsAppFloat() {
  return (
    <motion.a
      data-testid="whatsapp-float"
      href={waLink(WA_MESSAGES.general)}
      target="_blank"
      rel="noreferrer"
      aria-label="Escríbenos por WhatsApp"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 3, type: "spring", stiffness: 200, damping: 16 }}
      className="fixed bottom-6 right-6 z-50 group"
    >
      <span className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-25" />
      <span className="relative flex items-center gap-0 group-hover:gap-3 rounded-full bg-[#25D366] p-4 shadow-[0_10px_40px_rgba(37,211,102,0.35)] transition-all duration-500 overflow-hidden">
        <MessageCircle size={24} className="text-[#062b16] shrink-0" />
        <span className="max-w-0 group-hover:max-w-[180px] whitespace-nowrap overflow-hidden text-sm font-bold text-[#062b16] transition-all duration-500">
          Escríbenos ahora
        </span>
      </span>
    </motion.a>
  );
}
